import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import ControlledInputText from 'components/common/forms/controlled_input_text';

const NameFields = (props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const { address, store, namePrefix = '' } = props;

  return (
    <>
      <Grid
        item
        container
        direction={store === 'JP' ? 'row-reverse' : 'row'}
        spacing={2}
      >
        <Grid item xs={12} md={6}>
          <ControlledInputText
            name={`${namePrefix}first_name`}
            control={control}
            defaultValue={address.first_name}
            rules={{ required: true }}
            label={t('checkout.label.firstName')}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledInputText
            name={`${namePrefix}last_name`}
            control={control}
            defaultValue={address.last_name}
            rules={{ required: true }}
            label={t('checkout.label.lastName')}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={12}>
        <ControlledInputText
          name={`${namePrefix}company`}
          control={control}
          defaultValue={address.company}
          maxlength={40}
          rules={{ maxLength: 40 }}
          label={t('checkout.label.addressLine3')}
        />
      </Grid>
    </>
  );
};

export default NameFields;
